import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { Option } from '@/common/types';
import { API_URL } from '@/dtos';

export const QUERY_KEY = 'getSourceIds';

const useSourceIdsQuery = () => {
  const { data, isLoading, isSuccess } = useQuery([QUERY_KEY], () => api.get(API_URL.ENUMS_SOURCE_IDS), {
    retry: false,
  });
  const formatedData = useMemo<Option[]>(() => {
    const list = data?.data || [];
    return list.map((item) => ({
      key: `${item.name}`,
      value: item.description || '',
    }));
  }, [data]);
  return {
    data: formatedData,
    isLoading,
    isSuccess,
  };
};

export default useSourceIdsQuery;
